import { storage } from '@annunciate/core/dist/store/mmkv-store';
import { fetchKeys } from './fetchKeys';
export const fetchDownloadedData = async (cacheKey, uuid) => {
    if (!uuid)
        return [];
    const keys = await fetchKeys(cacheKey, uuid);
    const result = keys.map((key) => storage.getString(key));
    if (!result || !result.length) {
        return [];
    }
    else {
        try {
            return result.map((value) => {
                const parsedValue = value ? JSON.parse(value) : null;
                if (parsedValue) {
                    parsedValue.isDownload = true;
                }
                return parsedValue;
            });
        }
        catch (err) {
            console.error('Error while attempting to parse downloads', err);
            return [];
        }
    }
};
//# sourceMappingURL=fetchDownloadedData.js.map